var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0922 3.16675C8.07078 3.17369 5.96537 3.27286 4.61862 4.61862C3.16675 6.07049 3.16675 8.40796 3.16675 13.0829C3.16675 17.7579 3.16675 20.0953 4.61862 21.5482C6.07247 23.0001 8.40895 23.0001 13.0839 23.0001C17.7588 23.0001 20.0963 23.0001 21.5482 21.5482C22.8949 20.2024 22.9931 18.097 23.0001 14.0746",
    stroke: "#034A73",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0757 12.0922L23.0011 3.16675M23.0011 3.16675H17.7014M23.0011 3.16675V8.46647M22.0094 4.15846L13.084 13.0839M13.084 13.0839H17.0508M13.084 13.0839V9.11704",
    stroke: "#034A73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/square.140f07b4153ea8e1327b7fac55d8d190.svg";
export { ForwardRef as ReactComponent };